import PageLayout from '@/components/page/PageLayout.vue'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Step1 from '../Step1.vue'
import Step2 from '../Step2.vue'
import TaskApi from '@/api/task'
import { beforeAddTask } from '@/utils/order'
import SprFestModal from '@/components/Modal/SprFestModal.vue'

@Component({
	components: {
		SprFestModal,
		VNodes: {
			functional: true,
			render: (h: any, ctx: any) => ctx.props.vnodes,
		},
		PageLayout,
		Step1,
		Step2,
	},
})
export default class AddTask extends Vue {
	@Prop({ default: false })
	private toDetailOnOk!: boolean

	@Prop({ default: '' })
	private detailPath!: string

	@Prop({ default: false })
	private replaceRoute!: string

	private currentTab: any = 0
	private data: any = {}
	private resurveyOrder: any = false

	private nextStep() {
		if (this.currentTab < 2) {
			this.currentTab += 1
		}
	}

	private setManual2Injured(checked: boolean) {
		this.data.manual2Injured = checked
	}

	private clickPrev(form: any) {
		this.data = {
			...this.data,
			...form,
		}
		this.prevStep()
	}

	private resetCurrent() {
		this.currentTab = 0
	}

	private mounted() {
		beforeAddTask.call(this)
	}

	private onOk() {
		this.data = {}
		this.prevStep()
	}

	private get insuranceValue() {
		const value = this.$store.state.setting.insuranceTypeMap[
			this.data.insuranceType
		]
		if (value) {
			return this.subInsuranceValue ? `（${value}` : `（${value}）`
		}
		return ''
	}

	private get subInsuranceValue() {
		const value = this.$store.state.setting.subinsuranceTypeMap[
			this.data.subInsuranceType
		]
		if (value) {
			return `：${value}）`
		}
		return ''
	}

	private chooseInsuranceType(form: any) {
		this.data = {
			...this.data,
			...form,
		}
		this.nextStep()
	}

	private prevStep() {
		if (this.currentTab > 0) {
			this.currentTab -= 1
		}
	}

	private finish() {
		this.currentTab = 0
	}

	public created() {
		TaskApi.hasWholeProcessRight().then((res: any) => {
			// 检查是否有全流程权限
			this.$set(this.data, 'hasWholeProcessRight', res.data)
		})
	}
}
